import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export type DisconnectQontoResponse = {
  disconnectedAt: string;
  accountsSoftDeleted: number;
  alreadyDisconnected: boolean;
};

export function disconnectQontoErrorMessage(err: unknown): string {
  if (err && typeof err === 'object' && 'message' in err) {
    const message = String((err as { message: string }).message);
    if (message && !message.startsWith('Firebase')) {
      return message;
    }
  }
  if (err && typeof err === 'object' && 'code' in err) {
    const code = String((err as { code: string }).code);
    if (code === 'functions/failed-precondition') {
      return 'No Qonto connection found.';
    }
    if (code === 'functions/permission-denied') {
      return 'You do not have permission to disconnect this bank connection.';
    }
    if (code === 'functions/unauthenticated') {
      return 'Sign in to disconnect Qonto.';
    }
    if (code === 'functions/unavailable') {
      return 'Disconnect service is temporarily unavailable. Try again.';
    }
    if (code === 'functions/internal' || code === 'functions/deadline-exceeded') {
      return 'Could not disconnect Qonto. Try again.';
    }
  }
  return err instanceof Error ? err.message : 'Could not disconnect Qonto.';
}

export async function disconnectQonto(): Promise<DisconnectQontoResponse> {
  const fn = httpsCallable<void, DisconnectQontoResponse>(functions, 'disconnectQonto');
  const result = await fn();
  const disconnectedAt =
    typeof result.data.disconnectedAt === 'string' && result.data.disconnectedAt.trim()
      ? result.data.disconnectedAt
      : new Date().toISOString();
  const accountsSoftDeleted =
    typeof result.data.accountsSoftDeleted === 'number' &&
    Number.isFinite(result.data.accountsSoftDeleted)
      ? result.data.accountsSoftDeleted
      : 0;
  return {
    disconnectedAt,
    accountsSoftDeleted,
    alreadyDisconnected: result.data.alreadyDisconnected === true,
  };
}
